export const responseType = {
    json: 'json',
    file: 'file',
    none: 'none',
    text: 'text'
}
